import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { ILowStockProductModel } from "../models/inventoryOverviewModels";
import styles from "../InventoryOverviewPage.module.scss";

interface QuantityTabProps {
  products: ILowStockProductModel[];
  isLoading: boolean;
  hasLowStockItems: boolean;
  onCreateTransfer: () => void;
}

const SKELETON_COUNT = 4;

const getRowClass = (product: ILowStockProductModel): string => {
  if (product.currentQuantity <= product.lowStockThreshold) return styles.row_red;
  if (product.currentQuantity <= product.lowStockThreshold * 2) return styles.row_orange;
  return styles.row_normal;
};

const getQtyClass = (product: ILowStockProductModel): string => {
  if (product.currentQuantity <= product.lowStockThreshold) return styles.row_qty_red;
  if (product.currentQuantity <= product.lowStockThreshold * 2) return styles.row_qty_orange;
  return "";
};

const QuantitySkeleton = () => (
  <div className={styles.skeleton_list}>
    {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
      <div key={i} className={styles.skeleton_row}>
        <span className={styles.skeleton_emoji} />
        <span className={styles.skeleton_name} />
        <span className={styles.skeleton_qty} />
        <span className={styles.skeleton_badge} />
      </div>
    ))}
  </div>
);

export const QuantityTab = ({ products, isLoading, hasLowStockItems, onCreateTransfer }: QuantityTabProps) => {
  if (isLoading) {
    return <QuantitySkeleton />;
  }

  if (products.length === 0) {
    return (
      <div className={styles.empty_state}>
        <div className={styles.empty_icon}>📦</div>
        <div>Няма налични продукти.</div>
      </div>
    );
  }

  return (
    <>
      <div className={styles.list}>
        {products.map((product) => {
          const rowClass = getRowClass(product);
          const qtyClass = getQtyClass(product);

          return (
            <div
              key={product.inventoryItemId}
              className={`${styles.row} ${rowClass}`}
            >
              <span className={styles.row_emoji}>{product.categoryEmoji || "📦"}</span>
              <span className={styles.row_name}>{product.productName}</span>
              <span className={`${styles.row_qty} ${qtyClass}`}>
                {product.currentQuantity} бр.
              </span>
              <span className={styles.threshold_label}>
                праг: {product.lowStockThreshold}
              </span>
            </div>
          );
        })}
      </div>

      {hasLowStockItems && (
        <div className={styles.footer_action}>
          <DefaultButton
            label="Създай доставка"
            design="default"
            onClick={onCreateTransfer}
          />
        </div>
      )}
    </>
  );
};
